import apiService from "../../service/Api";
import { BlogDetail, BlogListResponse } from "./types";

// All blog reads are public: skipAuth=true so anonymous visitors get posts
// without a Bearer token. BaseURL ends in "/", so paths are relative.
const PAGES_URL = "api/cms/pages/";

const LIST_FIELDS = [
  "content_kind",
  "intro",
  "author_name",
  "publish_date",
  "is_featured",
  "category_api",
  "tags_list",
  "featured_image_thumb",
].join(",");

export interface ListPostsParams {
  limit?: number;
  offset?: number;
  search?: string;
}

export async function listPosts(
  params: ListPostsParams = {},
): Promise<BlogListResponse> {
  const response = await apiService.get<BlogListResponse>(
    PAGES_URL,
    { fields: LIST_FIELDS, order: "-publish_date", ...params },
    true,
  );
  const data = response.data;
  // Guard against a non-JSON response (e.g. a stale deploy serving index.html).
  return { meta: data?.meta ?? { total_count: 0 }, items: data?.items ?? [] };
}

export async function getPostBySlug(slug: string): Promise<BlogDetail | null> {
  // The Wagtail v2 API resolves a single page by slug through the list
  // endpoint with ?fields=* so the full body and renditions come through.
  const response = await apiService.get<{ items: BlogDetail[] }>(
    PAGES_URL,
    { slug, fields: "*" },
    true,
  );
  return response.data?.items?.[0] ?? null;
}
